import { SDKError } from "@smash-sdk/core";
export class GenericError extends SDKError {
}
export class FailedToDecodeTokenError extends GenericError {
}
export default {
    GenericError,
    FailedToDecodeTokenError,
};
